"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/offerSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type OfferSection4666sItem = {
    key: Key | null | undefined;
    /** Detected variants: "offers-item-thirteen wow fadeInUp" | "offers-item-thirteen two wow fadeInUp" | "offers-item-thirteen three wow fadeInUp" */
    className: string;
    /** Detected variants: "1s" | "2s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "Flat 25% OFF on All Medicines & Supplements" | "Save 30% on Diabetes Care & Medecines" | "Upto 50% on BabyCare Products" */
    h30Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/deals/offer-img-1.png" | "/Templates/Doccure/img/deals/offer-img-2.png" | "/Templates/Doccure/img/deals/offer-img-3.png" */
    src: string;
    /** Detected variants: "/Templates/Doccure/img/deals/shadow-img-1.png" | "/Templates/Doccure/img/deals/shadow-img-2.png" | "/Templates/Doccure/img/deals/shadow-img-3.png" */
    imageWithBasePath1Src: string;
    /** Detected variants: "Save instantly on prescription & medicines." | "Glucometers, strips, insulin pens & tablets." | "Discounts on soaps, diapers, creams & syrups." */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-4 col-lg-6 col-md-6 col-sm-6" */
    divClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "offer" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "offer" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid shadow-1" */
    imageWithBasePath1ClassName?: string;
};
export type HomeThirteenOfferSectionGeneratedProps = {
    divDiv0H30H3Props?: Partial<ComponentProps<"h3">> | ((item: OfferSection4666sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: OfferSection4666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: OfferSection4666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    sectionDiv0Div0ClassName?: string;
    offerSection4666s: OfferSection4666sItem[];
    offerSection4666sItemWrapper?: (item: OfferSection4666sItem, content: ReactNode) => ReactNode;
    offerSection4666sRenderer?: (defaultNode: ReactNode) => ReactNode;
    offerSection4666sImageVisible?: boolean;
    offerSection4666sImageRenderer?: (item: OfferSection4666sItem, defaultNode: ReactNode) => ReactNode;
    offerSection4666sH3Visible?: boolean;
    offerSection4666sH3Renderer?: (item: OfferSection4666sItem, defaultNode: ReactNode) => ReactNode;
    offerSection4666sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: OfferSection4666sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    offerSection4666sH3Props?: Partial<ComponentProps<"h3">> | ((item: OfferSection4666sItem) => Partial<ComponentProps<"h3">>);
};

const HomeThirteenOfferSectionGenerated: FC<HomeThirteenOfferSectionGeneratedProps> = ({
    divDiv0H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    divDiv0ImageWithBasePath1ImageProps,
    sectionDiv0Div0ClassName,
    offerSection4666s,
    offerSection4666sItemWrapper,
    offerSection4666sRenderer,
    offerSection4666sImageVisible,
    offerSection4666sImageRenderer,
    offerSection4666sH3Visible,
    offerSection4666sH3Renderer,
    offerSection4666sImageProps,
    offerSection4666sH3Props,
}) => {
    return (
        <section className="offers-section-thirteen section pt-0">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row g-4 justify-content-center"}>
                    {renderCollectionNode(
                        offerSection4666s,
                        (item: OfferSection4666sItem) => (
                            <div className={item.divClassName ?? "col-xl-4 col-lg-6 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.className} data-wow-duration={item.dataWowDuration}>
                                    {renderItemNode(offerSection4666sH3Visible, offerSection4666sH3Renderer, item, (
                                        <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof offerSection4666sH3Props === "function" ? offerSection4666sH3Props(item) : (offerSection4666sH3Props ?? {}))} {...(typeof divDiv0H30H3Props === "function" ? divDiv0H30H3Props(item) : (divDiv0H30H3Props ?? {}))}>{item.h30Text}</h3>
                                    ))}
                                    <p>{item.p0Text}</p>
                                    {renderItemNode(offerSection4666sImageVisible, offerSection4666sImageRenderer, item, (
                                        <SmartImage src={item.src} alt={item.alt ?? "offer"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof offerSection4666sImageProps === "function" ? offerSection4666sImageProps(item) : (offerSection4666sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                    ))}
                                    {renderItemNode(offerSection4666sImageVisible, offerSection4666sImageRenderer, item, (
                                        <SmartImage src={item.imageWithBasePath1Src} alt={item.imageWithBasePath1Alt ?? "offer"} className={item.imageWithBasePath1ClassName ?? "img-fluid shadow-1"} {...(typeof offerSection4666sImageProps === "function" ? offerSection4666sImageProps(item) : (offerSection4666sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath1ImageProps === "function" ? divDiv0ImageWithBasePath1ImageProps(item) : (divDiv0ImageWithBasePath1ImageProps ?? {}))} />
                                    ))}
                                </div>
                            </div>
                        ),
                        offerSection4666sItemWrapper,
                        offerSection4666sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeThirteenOfferSectionGenerated;
